import { ExplorerTransactionType } from '@/types/transaction'
import { env } from '@/config/env'

const { explorerUrl } = env
/**
 * Generates a Base blockchain explorer URL for a given address or transaction
 * @param address - The blockchain address or transaction ID to link to
 * @param type - The type of entity to link to (e.g., 'address' or 'tx')
 * @returns The full URL to view the address or transaction on BaseScan
 */
export function getBaseExplorerUrl(address: string, type: ExplorerTransactionType): string {
  const baseUrl = explorerUrl
  return `${baseUrl}/${type}/${address}`
}

